import { get } from 'lodash';
import { THEMES } from '@tools/constants';

export const selectTheme = (state) => get(state, 'user.preferences.theme', THEMES[0]);
export const selectIsDarkTheme = (state) => selectTheme(state) === THEMES[0];
